import React, { useState } from "react";
import {
  Search,
  TrendingUp,
  Target,
  Shield,
  BrainCircuit,
} from "lucide-react";

export default function StockPrediction() {
  const [symbol, setSymbol] = useState("");

  return (
    <div className="space-y-8">

      <div className="card-tactical rounded-2xl p-8">

        <h1 className="text-3xl font-bold">
          AI Stock Prediction
        </h1>

        <p className="text-white/60 mt-2">
          Predict future stock movement using AI.
        </p>

        <div className="flex gap-3 mt-6">

          <input
            value={symbol}
            onChange={(e)=>setSymbol(e.target.value.toUpperCase())}
            placeholder="AAPL"
            className="flex-1 bg-black/30 rounded-xl px-5 py-4 outline-none border border-white/10"
          />

          <button
            className="px-6 rounded-xl bg-blue-600 hover:bg-blue-700 transition"
          >
            <Search />
          </button>

        </div>

      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5">

        <div className="card-tactical rounded-xl p-6">
          <TrendingUp size={35}/>
          <div className="text-sm text-white/60 mt-4">
            Signal
          </div>

          <div className="text-3xl font-bold text-green-400 mt-2">
            BUY
          </div>
        </div>

        <div className="card-tactical rounded-xl p-6">
          <Target size={35}/>
          <div className="text-sm text-white/60 mt-4">
            Target
          </div>

          <div className="text-3xl font-bold mt-2">
            $250
          </div>
        </div>

        <div className="card-tactical rounded-xl p-6">
          <Shield size={35}/>
          <div className="text-sm text-white/60 mt-4">
            Stop Loss
          </div>

          <div className="text-3xl font-bold mt-2">
            $235
          </div>
        </div>

        <div className="card-tactical rounded-xl p-6">
          <BrainCircuit size={35}/>
          <div className="text-sm text-white/60 mt-4">
            Confidence
          </div>

          <div className="text-3xl font-bold mt-2">
            91%
          </div>
        </div>

      </div>

      <div className="card-tactical rounded-2xl p-8">

        <h2 className="text-2xl font-bold mb-5">
          AI Analysis
        </h2>

        <div className="space-y-4 text-white/70">

          <div>✔ Strong Bullish Momentum</div>

          <div>✔ RSI indicates buying opportunity</div>

          <div>✔ MACD crossover confirmed</div>

          <div>✔ Institutional buying detected</div>

          <div>✔ Volume increasing above average</div>

        </div>

      </div>

    </div>
  );
}
